import { Injectable } from '@angular/core';
import { clientLegalName, isGuarantor } from '@core/util/client';
import { isSet } from '@core/util/value';
import { Business, BusinessAddress } from '@models/businesses';
import {
	BusinessMatterClient,
	BusinessMatterClientWithAssociations,
	CalculatedLandTransferTax,
	ClientsCapacity,
	Matter,
	MatterTitle,
	PersonMatterClient,
	PersonMatterClientWithAssociations,
} from '@models/matter';
import { MatterMortgage } from '@models/mortgage';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';
import { joinNames } from '@core/util/string';

@Injectable({
	providedIn: 'root',
})
export class TD_SCHEDULE_1_Mapper extends BaseFormMapper<TD_SCHEDULE_1> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: TD_SCHEDULE_1,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
		matterTitles: MatterTitle[],
		matterClients: (
			| PersonMatterClientWithAssociations
			| BusinessMatterClientWithAssociations
		)[],
		lttCalculated: CalculatedLandTransferTax,
		businessAddress: BusinessAddress,
		otherParties: PersonMatterClient[],
		clientsCapacity: ClientsCapacity,
		mortgage: MatterMortgage,
	): TD_SCHEDULE_1 {
		const _formData = formData ? cloneDeep(formData) : ({} as TD_SCHEDULE_1);
		const filteredMatterClients = matterClients?.filter(
			(client) => !isGuarantor(client),
		);

		if (filteredMatterClients?.length && !isSet(_formData?.clientNames1)) {
			_formData.clientNames1 = joinNames(
				filteredMatterClients.map((client) =>
					clientLegalName(client, nameFormattingSettings, {
						applyFormatting: false,
					}),
				),
			);
		}

		if (isSet(mortgage?.interestRate) && !isSet(_formData?.interestRate)) {
			_formData.interestRate = mortgage.interestRate.toString();
		}

		return _formData;
	}

	MapValues(): Partial<TD_SCHEDULE_1> {
		return {};
	}
}

const Mappings: TD_SCHEDULE_1 = {
	clientNames1: 'ClientNames1',
	clientNames2: 'ClientNames2',
	interestRate: 'InterestRate',
};

export interface TD_SCHEDULE_1 {
	clientNames1: string;
	clientNames2: string;
	interestRate: string;
}
